export const LANG = process.env.REACT_APP_LANG;

let dataFilename = 'vocabulary-en';

let text1 = 'Blue';
let text2 = 'Pink';
let text3 = 'Green';
let text4 = 'Orange';
let text5 = 'Pantoparty for adults';
let text6 = 'Normal Mode';
let text7 = 'Pantoparty for kids';
let text8 = 'Easy Mode for Kids';
let text9 = 'Add Team';
let text10 = 'Play';
let text11 = 'Back';
let text12 = 'Help';
let text13 = 'Winner';
let text14 = 'Draw Card';
let text15 = 'Draw';
let text16 = 'Next';
let text17 = 'Start a new game?';
let text18 = 'Yes';
let text19 = 'No';
let text20 = 'Start a new game';

let help1 = 'One player draws a card with 5 random words. It is his job to act them out in the desired order.';
let help2 = 'Other team members have to guess.';
let help3 = 'They have 3 minutes to guess all the words.';
let help4 = 'For each guessed word the team gets 1 point.';
let help5 = 'The game is played for 5 rounds. The team that scores the most points wins.';

if (process.env.REACT_APP_LANG === 'hr') {
    dataFilename = 'vocabulary-hr';

    text1 = 'Plavi';
    text2 = 'Rozi';
    text3 = 'Zeleni';
    text4 = 'Narančasti';
    text5 = 'Pantoparty za odrasle';
    text6 = 'Standardni način';
    text7 = 'Pantoparty za djecu';
    text8 = 'Lagani način za djecu';
    text9 = 'Dodaj ekipu';
    text10 = 'Igraj';
    text11 = 'Nazad';
    text12 = 'Pomoć';
    text13 = 'Pobjednik';
    text14 = 'Izvuci kartu';
    text15 = 'Neriješeno';
    text16 = 'Sljedeći';
    text17 = 'Započni novu igru?';
    text18 = 'Da';
    text19 = 'Ne';
    text20 = 'Započni novu igru';

    
    help1 = 'Jedan igrač izvlači kartu s 5 slučajnih pojmova. Njegov je zadatak oponašati ih u željenom redoslijedu.';
    help2 = 'Ostali članovi ekipe pogađaju.';
    help3 = 'Imaju 3 minute da pogode sve pojmove.';
    help4 = 'Za svaki pogođeni pojam ekipa dobije 1 bod.';
    help5 = 'Igra se 5 krugova. Ekipa koja skupi najviše bodova pobjeđuje.';

}

export const DATAFILENAME = dataFilename;

export const TEXT1 = text1;
export const TEXT2 = text2;
export const TEXT3 = text3;
export const TEXT4 = text4;
export const TEXT5 = text5;
export const TEXT6 = text6;
export const TEXT7 = text7;
export const TEXT8 = text8;
export const TEXT9 = text9;
export const TEXT10 = text10;
export const TEXT11 = text11;
export const TEXT12 = text12;
export const TEXT13 = text13;
export const TEXT14 = text14;
export const TEXT15 = text15;
export const TEXT16 = text16;
export const TEXT17 = text17;
export const TEXT18 = text18;
export const TEXT19 = text19;
export const TEXT20 = text20;

export const HELP1 = help1;
export const HELP2 = help2;
export const HELP3 = help3;
export const HELP4 = help4;
export const HELP5 = help5;
// end language